var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:none;stroke:#175b3e;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:2.6131}.st7{stroke:#e6f9f0;stroke-linecap:round;stroke-miterlimit:10}.st11,.st12,.st7,.st9{fill:none;stroke-width:2}.st9{stroke:#2ec986;stroke-linejoin:round;stroke-miterlimit:2.6131}.st11,.st12{stroke-linecap:round}.st11{stroke-linejoin:round;stroke-miterlimit:2.6131;stroke:#175b3e}.st12{stroke:#42a87c}.st14{opacity:.15}.st14,.st15{fill:#1ec98d}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.1 127.2V24.8c0-3.3-2.7-6-6-6H46.9c-3.3 0-6 2.7-6 6v102.3c0 3.3 2.7 6 6 6h58.2c3.3.1 6-2.6 6-5.9z",
    opacity: 0.19,
    fill: "#2ec986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 74.2v48.9c0 3.3 2.7 6 6 6h58.2c3.3 0 6-2.7 6-6V20.8c0-3.3-2.7-6-6-6H42.9c-3.3 0-6 2.7-6 6V30",
    fill: "#e6f9f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 74.2v48.9c0 3.3 2.7 6 6 6h58.2c3.3 0 6-2.7 6-6V20.8c0-3.3-2.7-6-6-6H42.9c-3.3 0-6 2.7-6 6V30",
    fill: "none",
    stroke: "#175b3e",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 2.613
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.4 34.8h-5M39.4 40.6h-5M39.4 46.4h-5M39.4 52.1h-5M39.4 57.9h-5M39.4 63.7h-5M39.4 69.4h-5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f6fdfa",
    stroke: "#175b3e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    d: "M99.2 96.6v19.3H44.8V26.6h54.4v58.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 122,
    r: 2.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#175b3e",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175b3e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 2.613,
    d: "M66.5 21.4h11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.8 47.6v63M49.8 37.4V44M49.8 32.5v1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.8 38.4h10v10h-10zM76.2 38.4h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#279b69",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    d: "M58.8 57.3h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M76.2 57.3h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.8 75.2h10v10h-10zM76.2 75.2h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.8 94.5h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.2 94.5h10v10h-10z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 99.2,
    cy: 90.4,
    r: 1.5,
    fill: "none",
    stroke: "#175b3e",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.1 123.5l-1.5-2.6M18.8 122.7l2-2.2M17.3 115.5l2.7 1.2M23.7 111.8l-.4 3M29.1 116.7l-2.9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139.7 104.4c-1.1 2.2-3.4 3.7-5.8 4M129.3 107.5c-2.2-1.1-3.7-3.4-4-5.8M126.2 97.2c1.1-2.2 3.4-3.7 5.8-4M136.5 94c2.2 1.1 3.7 3.4 4 5.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.2 131.8c-.7 0-3.1 2.4-3.1 3.1 0-.7-2.4-3.1-3.1-3.1.7 0 3.1-2.4 3.1-3.1 0 .7 2.5 3.1 3.1 3.1z",
    fill: "#dfab29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 11.8,
    cy: 92.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 10.4,
    cy: 91,
    r: 3.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 15.1,
    cy: 44.2,
    r: 1.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 130.4,
    cy: 26.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 129.1,
    cy: 25.5,
    r: 3.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.af789b1e3de56bb89d001b01c11c30bb.svg";
export { ForwardRef as ReactComponent };